import fixDateTimezone from './fixDateTimezone';

// Колонка signedAt — timestamp без зоны: бэк отдаёт UTC без «Z», и dayjs читал бы его как локальное время.
// Показываем всегда по Казахстану (UTC+5), как в PDF согласия, — независимо от пояса зрителя.
const asUtc = (value) => (/(Z|[+-]\d\d:?\d\d)$/.test(value) ? value : `${value}Z`);

const formatSignedAt = (value) => (value ? fixDateTimezone(asUtc(value)).format('DD.MM.YYYY HH:mm:ss') : '—');

export default formatSignedAt;
